var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"achievement"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"project"},[_c('projectItem',{attrs:{"projectData":_vm.projectData}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"ban-title inner"},[_vm._v("典型业绩")])])
}]

export { render, staticRenderFns }